export default {
  type: "Feature",
  properties: {
    name: "Тосонцэнгэл",
    location: [48.36342669373499, 97.72806903152032],
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[48.764629871623406, 98.27009484029412]]],
  },
};
